import { Stack } from 'react-bootstrap';
import { BigButton, Checkbox } from '../../common';
import MyDropzone from '../../components/MyDropzone';
import BinIcon from '../../components/icons/BinIcon';
import { warningToast } from '../../helpers/toastHelper';
import { useState } from 'react';

export const UploadWithItemListModal = ({
  title = 'Upload',
  subTitle = 'or drag and drop your item here',
  accept = null,
  type = null,
  restrictMultiple = false,
  noInlineStyle = false,
  buttonTitle = 'Upload',
  onClick = () => {},
  loading = false,
  showHeader = false,
  columns = [],
  children,
}) => {
  const [files, setFiles] = useState([]);

  const onDrop = (newFiles = []) => {
    if (loading) {
      warningToast('Unable to add an items while uploading');
      return;
    }
    const uniqueFiles = restrictMultiple ? [...newFiles] : [...new Set([...files, ...newFiles])];
    setFiles(uniqueFiles.map((file) => ({ file, name: file.name })));
  };

  const onDelete = (fileIndex) => {
    if (loading) {
      warningToast('Unable to delete items while uploading');
      return;
    }
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== fileIndex));
  };

  const handleCheck = (name = '', key = null, value = false) => {
    if (!name || !key) return;
    setFiles((prev) =>
      prev.map((f) => {
        if ({ ...f }.name?.trim()?.toLowerCase() === name?.trim()?.toLowerCase()) {
          return {
            ...f,
            [key]: value,
          };
        }
        return f;
      })
    );
  };

  if (!type) return null;

  return (
    <>
      <MyDropzone
        title={title}
        subTitle={subTitle}
        onDrop={onDrop}
        accept={accept}
        restrictMultiple={restrictMultiple}
        noInlineStyle={noInlineStyle}
      />
      {children}
      {files.length > 0 ? (
        <Stack>
          <div
            style={{
              maxHeight: 214,
              overflowY: 'auto',
              marginTop: '1.5rem',
              marginBottom: '2rem',
            }}>
            <table className="bordered">
              {showHeader ? (
                <thead>
                  <tr>
                    <td>
                      <span>
                        <strong>Name</strong>
                      </span>
                      {columns.map((column, index) => (
                        <span key={index}>
                          <strong>{column.label}</strong>
                        </span>
                      ))}
                      <span>
                        <strong>Action</strong>
                      </span>
                    </td>
                  </tr>
                </thead>
              ) : null}
              <tbody>
                {files.map((file, index) => (
                  <tr key={index}>
                    <td>
                      <span>{file.name}</span>
                      {columns.map((column, index) => (
                        <span key={index}>
                          <Checkbox
                            selected={Boolean(file[column.key])}
                            onChange={() => handleCheck(file.name, column.key, !file[column.key])}
                            className="selectAll"
                          />
                        </span>
                      ))}
                      <span onClick={() => onDelete(index)} style={{ cursor: 'pointer' }}>
                        <BinIcon />
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <BigButton
            disabled={loading}
            isLoading={loading}
            className="lf-btn-1"
            buttonTitle={buttonTitle}
            onClick={() => onClick?.(files, type)}
          />
        </Stack>
      ) : null}
    </>
  );
};
